import React, { useState, useCallback } from 'react';
import { Check, Warning, Fire } from '@phosphor-icons/react';

let showToastGlobal = null;

export function useToast() {
  const [toast, setToast] = useState(null);

  const show = useCallback((message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 2500);
  }, []);

  showToastGlobal = show;
  return { toast, showToast: show };
}

export function getToast() {
  return showToastGlobal;
}

export default function Toast({ toast }) {
  if (!toast) return null;

  const icons = {
    success: <Check size={20} weight="bold" />,
    error: <Warning size={20} weight="bold" />,
    fire: <Fire size={20} weight="bold" />,
  };

  const colors = {
    success: 'bg-success/20 border-success/40 text-success',
    error: 'bg-red-500/20 border-red-500/40 text-red-400',
    fire: 'bg-warning/20 border-warning/40 text-warning',
  };

  return (
    <div className="fixed top-8 left-4 right-4 z-[200] flex justify-center pointer-events-none" data-testid="toast-notification">
      <div className={`flex items-center gap-3 px-5 py-4 rounded-md border backdrop-blur-sm max-w-md w-full animate-slide-down ${colors[toast.type] || colors.success}`}>
        {icons[toast.type] || icons.success}
        <span className="font-bold text-sm uppercase tracking-wide">{toast.message}</span>
      </div>
    </div>
  );
}
